export default [
  {
    name: 'Control Contable',
    icon: 'mdi-file-excel-outline',
    path: '/admin/accounting-control',
    component: () =>
      import(/* webpackChunkName: "admin-fiscal-obligations" */ './views/AccountingControl'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
